/**
 * Transaction type constants for financial operations
 */
export const TRANSACTION_TYPES = {
  /**
   * Credit transaction type
   */
  CREDIT: 'C',
  
  /**
   * Debit transaction type
   */
  DEBIT: 'D'
} as const;

/**
 * Type for transaction type values
 */
export type TransactionType = typeof TRANSACTION_TYPES[keyof typeof TRANSACTION_TYPES];
